/**
 * Mappa EN -> IT dei nomi paese usata dai widget mappa della dashboard.
 *
 * Le chiavi corrispondono ESATTAMENTE alla proprieta `name` delle feature dei GeoJSON
 * dei due widget mappa del portale:
 *  - `@sia/dash` (DevExtreme `dx-vector-map`, `sia-dash-widget-map`): GeoJSON `world.ts` (176 nomi).
 *  - `@sia/dashboard` (ECharts `geo: { map: 'world' }`, `dashboard-widget-map`): GeoJSON
 *    `world.json` (215 nomi, set piu ampio: include molte isole/territori).
 * Questo dizionario contiene la UNION dei due set (219 chiavi) cosi copre entrambe le mappe.
 *
 * WHY EN->IT: i due GeoJSON hanno la proprieta `name` in INGLESE. Il portale vuole mostrare i
 * paesi di default in ITALIANO; la stringa italiana viene poi passata a `SiaI18nService.translate()`,
 * che la traduce verso EN/altre lingue quando l'utente non e in IT (auto-discovery delle chiavi
 * mancanti). Il nome italiano e quindi la stringa SORGENTE per il sistema i18n.
 *
 * WHY in `@sia/shared`: il dizionario serve a DUE librerie (`@sia/dash` e `@sia/dashboard`) che non
 * dipendono l'una dall'altra ma dipendono entrambe da `@sia/shared` → single source of truth, nessun
 * edge di dipendenza nuovo, nessuna duplicazione da mantenere allineata.
 *
 * Per nomi non mappati il chiamante ricade sul nome originale (vedi `getCountryNameIt`).
 */
export const COUNTRY_NAMES_IT: Record<string, string> = {
  Afghanistan: 'Afghanistan',
  Aland: 'Isole Aland',
  Albania: 'Albania',
  Algeria: 'Algeria',
  'American Samoa': 'Samoa Americane',
  Andorra: 'Andorra',
  Angola: 'Angola',
  Antarctica: 'Antartide',
  'Antigua and Barb.': 'Antigua e Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaigian',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrein',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Bielorussia',
  Belgium: 'Belgio',
  Belize: 'Belize',
  Benin: 'Benin',
  Bermuda: 'Bermuda',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia',
  'Bosnia and Herz.': 'Bosnia ed Erzegovina',
  Botswana: 'Botswana',
  'Br. Indian Ocean Ter.': "Territorio britannico dell'Oceano Indiano",
  Brazil: 'Brasile',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Cambogia',
  Cameroon: 'Camerun',
  Canada: 'Canada',
  'Cape Verde': 'Capo Verde',
  'Cayman Is.': 'Isole Cayman',
  'Central African Rep.': 'Rep. Centrafricana',
  Chad: 'Ciad',
  Chile: 'Cile',
  China: 'Cina',
  Colombia: 'Colombia',
  Comoros: 'Comore',
  Congo: 'Congo',
  'Costa Rica': 'Costa Rica',
  "Côte d'Ivoire": "Costa d'Avorio",
  Croatia: 'Croazia',
  Cuba: 'Cuba',
  Curaçao: 'Curaçao',
  Cyprus: 'Cipro',
  'Czech Rep.': 'Repubblica Ceca',
  'Dem. Rep. Congo': 'Rep. Dem. del Congo',
  'Dem. Rep. Korea': 'Corea del Nord',
  Denmark: 'Danimarca',
  Djibouti: 'Gibuti',
  Dominica: 'Dominica',
  'Dominican Rep.': 'Repubblica Dominicana',
  Ecuador: 'Ecuador',
  Egypt: 'Egitto',
  'El Salvador': 'El Salvador',
  'Eq. Guinea': 'Guinea Equatoriale',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Etiopia',
  'Faeroe Is.': 'Isole Faroe',
  'Falkland Is.': 'Isole Falkland',
  Fiji: 'Figi',
  Finland: 'Finlandia',
  France: 'Francia',
  'Fr. Polynesia': 'Polinesia Francese',
  'Fr. S. Antarctic Lands': 'Terre australi e antartiche francesi',
  Gabon: 'Gabon',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Germania',
  Ghana: 'Ghana',
  Greece: 'Grecia',
  Greenland: 'Groenlandia',
  Grenada: 'Grenada',
  Guam: 'Guam',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Guyana: 'Guyana',
  Haiti: 'Haiti',
  'Heard I. and McDonald Is.': 'Isole Heard e McDonald',
  Honduras: 'Honduras',
  Hungary: 'Ungheria',
  Iceland: 'Islanda',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Iran',
  Iraq: 'Iraq',
  Ireland: 'Irlanda',
  'Isle of Man': 'Isola di Man',
  Israel: 'Israele',
  Italy: 'Italia',
  Jamaica: 'Giamaica',
  Japan: 'Giappone',
  Jersey: 'Jersey',
  Jordan: 'Giordania',
  Kazakhstan: 'Kazakistan',
  Kenya: 'Kenya',
  Kiribati: 'Kiribati',
  Korea: 'Corea del Sud',
  Kosovo: 'Kosovo',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kirghizistan',
  'Lao PDR': 'Laos',
  Latvia: 'Lettonia',
  Lebanon: 'Libano',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituania',
  Luxembourg: 'Lussemburgo',
  Macedonia: 'Macedonia',
  Madagascar: 'Madagascar',
  Malawi: 'Malawi',
  Malaysia: 'Malaysia',
  Mali: 'Mali',
  Malta: 'Malta',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mexico: 'Messico',
  Micronesia: 'Micronesia',
  Moldova: 'Moldavia',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Montserrat: 'Montserrat',
  Morocco: 'Marocco',
  Mozambique: 'Mozambico',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  'N. Cyprus': 'Cipro del Nord',
  'N. Mariana Is.': 'Isole Marianne Settentrionali',
  Nepal: 'Nepal',
  Netherlands: 'Paesi Bassi',
  'New Caledonia': 'Nuova Caledonia',
  'New Zealand': 'Nuova Zelanda',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  Niue: 'Niue',
  Norway: 'Norvegia',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Palestine: 'Palestina',
  Panama: 'Panama',
  'Papua New Guinea': 'Papua Nuova Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Peru',
  Philippines: 'Filippine',
  Poland: 'Polonia',
  Portugal: 'Portogallo',
  'Puerto Rico': 'Porto Rico',
  Qatar: 'Qatar',
  Romania: 'Romania',
  Russia: 'Russia',
  Rwanda: 'Ruanda',
  'Saint Helena': "Sant'Elena",
  'Saint Lucia': 'Santa Lucia',
  Samoa: 'Samoa',
  'Saudi Arabia': 'Arabia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'S. Geo. and S. Sandw. Is.': 'Georgia del Sud e Isole Sandwich Australi',
  'Siachen Glacier': 'Ghiacciaio del Siachen',
  'Sierra Leone': 'Sierra Leone',
  Singapore: 'Singapore',
  Slovakia: 'Slovacchia',
  Slovenia: 'Slovenia',
  'Solomon Is.': 'Isole Salomone',
  Somalia: 'Somalia',
  Somaliland: 'Somaliland',
  'South Africa': 'Sudafrica',
  Spain: 'Spagna',
  'Sri Lanka': 'Sri Lanka',
  'St. Pierre and Miquelon': 'Saint-Pierre e Miquelon',
  'St. Vin. and Gren.': 'Saint Vincent e Grenadine',
  'S. Sudan': 'Sud Sudan',
  Sudan: 'Sudan',
  Suriname: 'Suriname',
  Swaziland: 'Eswatini',
  Sweden: 'Svezia',
  Switzerland: 'Svizzera',
  Syria: 'Siria',
  'São Tomé and Principe': 'São Tomé e Príncipe',
  Taiwan: 'Taiwan',
  Tajikistan: 'Tagikistan',
  Tanzania: 'Tanzania',
  Thailand: 'Thailandia',
  'Timor-Leste': 'Timor Est',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad e Tobago',
  Tunisia: 'Tunisia',
  Turkey: 'Turchia',
  Turkmenistan: 'Turkmenistan',
  'Turks and Caicos Is.': 'Isole Turks e Caicos',
  Uganda: 'Uganda',
  Ukraine: 'Ucraina',
  'United Arab Emirates': 'Emirati Arabi Uniti',
  'United Kingdom': 'Regno Unito',
  'United States': 'Stati Uniti',
  Uruguay: 'Uruguay',
  'U.S. Virgin Is.': 'Isole Vergini Americane',
  Uzbekistan: 'Uzbekistan',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  'W. Sahara': 'Sahara Occidentale',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabwe',
};

/**
 * Ritorna il nome italiano del paese a partire dal nome inglese del GeoJSON.
 * Fallback al nome originale per paesi non mappati (es. dataSource futuro modificato).
 */
export function getCountryNameIt(enName: string | undefined | null): string {
  if (!enName) {
    return '';
  }
  return COUNTRY_NAMES_IT[enName] ?? enName;
}
